var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reference-iiko layout" },
    [
      _c("access-sidesheet", {
        ref: "accessModal",
        on: {
          updated: _vm.updateAccessData,
          created: _vm.addAccessData,
          remove: function ($event) {
            return _vm.updateList()
          },
        },
      }),
      _c("remove-access-modal", {
        ref: "removeAccessModal",
        on: {
          remove: function ($event) {
            return _vm.updateList()
          },
        },
      }),
      _c("div", { staticClass: "layout-header" }, [
        _c("div", { staticClass: "layout-title" }, [
          _vm._v("Настройки доступов к IIKO"),
        ]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button2", {
                attrs: {
                  size: "small",
                  icon: {
                    icon: "bookmark",
                    activeColor: "white",
                  },
                  tooltip: {
                    text: "Добавить в закладки",
                    activeText: "Убрать из закладок",
                  },
                  "active-color": "blue",
                  active: _vm.bookmark,
                },
                on: {
                  click: function ($event) {
                    _vm.bookmark = !_vm.bookmark
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button2", {
                attrs: {
                  responsive: true,
                  size: "small",
                  label: "Новый доступ",
                  icon: { icon: "plus", color: "primary" },
                },
                on: { click: _vm.addAccess },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "reference-iiko__content" },
        [
          _c(
            "div",
            { staticClass: "reference-iiko__search" },
            [
              _c("c-input", {
                attrs: {
                  placeholder: "Поиск по названию/ID терминала, хосту, логину",
                  clearable: true,
                  icon: "search",
                },
                on: { enter: _vm.updateList },
                model: {
                  value: _vm.query,
                  callback: function ($$v) {
                    _vm.query = $$v
                  },
                  expression: "query",
                },
              }),
            ],
            1
          ),
          _vm.inited
            ? [
                _c("accesses-table", {
                  attrs: {
                    loading: _vm.loading,
                    list: _vm.list,
                    "sort-by": _vm.sortBy,
                    page: _vm.page,
                  },
                  on: {
                    sort: _vm.sort,
                    nextPage: _vm.nextPage,
                    remove: _vm.removeAccess,
                    edit: _vm.editAccess,
                  },
                }),
              ]
            : _vm._e(),
          !_vm.inited
            ? _c("c-loader", {
                attrs: {
                  active: !_vm.inited,
                  label: "Данные загружаются",
                  height: 300,
                },
              })
            : _vm._e(),
        ],
        2
      ),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }